<!-- Spacer -->
<div
    class="cipafacil-vertical-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
